<ul class="nav btn-tab-group d-flex justify-content-around">
    <li class="nav-item flex-grow-1 text-center">
        <a class="nav-link btn-tab active" id="#reservation-tab" data-bs-toggle="tab" href="#reservation" role="tab">
            <app-icon icon="Calendar"></app-icon>
        </a>
    </li>
    <li class="nav-item flex-grow-1 text-center">
        @if ((filteredReservations | reservationsByTypeFilter:waitingType).length > 0) {
            <span class="badge">{{(filteredReservations | reservationsByTypeFilter:waitingType).length}}</span>
        }
        <a class="nav-link btn-tab" id="#waiting-tab" data-bs-toggle="tab" href="#waiting" role="tab">
            <app-icon icon="Hourglass"></app-icon>
        </a>
    </li>
    <li class="nav-item flex-grow-1 text-center">
        @if ((filteredReservations | reservationsByTypeFilter:pendingType).length > 0) {
            <span class="badge">{{(filteredReservations | reservationsByTypeFilter:pendingType).length}}</span>
        }
        <a class="nav-link btn-tab" id="#pending-tab" data-bs-toggle="tab" href="#pending" role="tab">
            <app-icon icon="Questionmark"></app-icon>
        </a>
    </li>
</ul>

<div id="use-mode-reservations" class="tab-content">
    <!-- reservation -->
    <div class="tab-pane fade show active" id="reservation" role="tabpanel">
        <div class="container-sm">

            <!-- booked -->
            <ng-container
                *ngTemplateOutlet="reservationscategory;context:{reservationType: bookedType, headerLabel: 'booked', expanded: true}"></ng-container>

            <!-- seated -->
            <ng-container
                *ngTemplateOutlet="reservationscategory;context:{reservationType: seatedType, headerLabel: 'seated', expanded: true}"></ng-container>

            <!-- completed -->
            <ng-container
                *ngTemplateOutlet="reservationscategory;context:{reservationType: completedType, headerLabel: 'completed'}"></ng-container>

        </div>
    </div>

    <!-- waiting -->
    <div class="tab-pane fade" id="waiting" role="tabpanel">
        <div class="container-sm">

            <ng-container
                *ngTemplateOutlet="reservationscategory;context:{reservationType: waitingType, headerLabel: 'waiting', expanded: true}"></ng-container>

        </div>
    </div>

    <!-- pending -->
    <div class="tab-pane fade" id="pending" role="tabpanel">
        <div class="container-sm">

            <ng-container
                *ngTemplateOutlet="reservationscategory;context:{reservationType: pendingType, headerLabel: 'pending', expanded: true}"></ng-container>

        </div>
    </div>
</div>

<ng-template #reservationscategory let-reservationType="reservationType" let-headerLabel="headerLabel" let-expanded="expanded">
    <div class="list-item-collapsible list-item-collapsible-has-value">
        <a [class]="'list-item-collapsible-header d-flex flex-row justify-content-between ' + (!expanded ? 'collapsed' : '')" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapsereservation' + reservationType" aria-expanded="false">
            <span class="list-item-collapsible-label">{{'tablesPlan.useMode.reservations.' + headerLabel |
                translate }}</span>
            <span class="list-item-collapsible-label d-flex flex-row">
                <span class="covers">{{filteredReservations | coversByReservationType:reservationType}}</span>
                <app-icon icon="ChevronDown" class="toggle-icon"></app-icon>
            </span>
        </a>
        <!-- data-bs-parent="#use-mode-reservations" -->
        <div [id]="'collapsereservation' + reservationType" [class]="'collapse ' + (expanded ? 'show' : '')">
            <div class="list-item-collapsible-content">
                @for (reservation of filteredReservations | reservationsByTypeFilter:reservationType; track
                reservation.reservationDetails.reservationId) {
                <app-tables-plan-use-reservation [reservation]="reservation"></app-tables-plan-use-reservation>
                }
            </div>
        </div>
    </div>
</ng-template>

<!-- status modal -->
<app-reservation-status-modal></app-reservation-status-modal>